import { Component, Input, forwardRef, ChangeDetectionStrategy } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

const TYPE_CONTROL_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(() => RadioButtonComponent)
    // multi: true
};

@Component({
    selector: 'dp-radio-button',
    templateUrl: './radio-button.component.html',
    styleUrls: ['./radio-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [TYPE_CONTROL_ACCESSOR]
})
export class RadioButtonComponent implements ControlValueAccessor {
    private onTouch: Function;
    private onModelChange: Function;
    @Input() public id: string = Math.random()
        .toString(36)
        .substr(2, 16);
    @Input() public name: string;
    @Input() public title: string;
    @Input() public value = '';
    @Input() public disabled: boolean;
    @Input() public checked: boolean;

    public writeValue(obj: string): void {
        this.value = obj;
    }

    public registerOnChange(fn: any): void {
        this.onModelChange = fn;
    }

    public registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }
}
